import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";


@Injectable({ providedIn: "root" })
export class AuthGuard  {
  constructor(
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let currentUser: unknown;
    try {
      currentUser = JSON.parse(sessionStorage.getItem('userInfo') ?? 'null');
    } catch (error) {
      if (!(error instanceof SyntaxError)) throw error;
      this.router.navigate(['/login']);
      return false;
    }
    if (typeof currentUser === 'object' && currentUser !== null && !Array.isArray(currentUser)) {
      const requiredRoles: unknown = route.data.roles;
      if (requiredRoles === undefined) return true;
      const userRoles: unknown = 'roles' in currentUser ? currentUser.roles : undefined;
      if (Array.isArray(requiredRoles) && Array.isArray(userRoles) &&
          requiredRoles.some(role => typeof role === 'string' && userRoles.includes(role))) {
        return true;
      }
      this.router.navigate(['404']);
      return false;
    }

    // not logged in
    this.router.navigate(["/login"]);
    return false;
  }
}

